import { getAuthAxiosBackend } from "@/helpers/axios"

class TownshipsServices {
    get(id) {
        return getAuthAxiosBackend().get('Townships/getTownshipsById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('Townships/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('Townships/addTownships', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('Townships/updateTownships/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('Townships/restoreTownships' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('Townships/softDeleteTownships/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('Townships/deleteTownships/' + id.toString())
    }
}

export default new TownshipsServices()